import { render, staticRenderFns } from "./user_tag.vue?vue&type=template&id=76c6dbba&"
import script from "./user_tag.vue?vue&type=script&lang=ts&"
export * from "./user_tag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports